export default __webpack_public_path__ + "static/media/hhs-qld-central-west.44e3c7b7.svg";